/**
 * Keep this configuration in sync with
 * https://dev.azure.com/estimationworld/Estimation%20Tool/_git/EstimationTool?path=/src/api/EstiWorld.Core/Configuration/StaticSettings.cs
 */
export const entityFieldSettings = {
  tenantEntity: {
    nameMaxLength: 100,
    descriptionMaxLength: 1000,
    defaultCultureNameMaxLength: 10,
    logoUrlMaxLength: 1000,
    logoMaxSizeInKB: 2048,
    identityProviderMaxLength: 1000,
  },
  userEntity: {
    forenameMaxLength: 100,
    surnameMaxLength: 100,
    emailMaxLength: 254,
    cultureNameMaxLength: 10,
  },
  commentEntity: {
    textMaxLength: 1000,
    textStrippedHtmlMaxLength: 210,
  },
  currencyEntity: {
    nameMaxLength: 20,
    codeMaxLength: 3,
    symbolMaxLength: 1 /* like $, €, £, etc.*/,
  },
  localizationEntity: {
    cultureNameMaxLength: 10,
    keyMaxLength: 100,
  },
  projectTypeEntity: {
    nameMaxLength: 50,
    descriptionMaxLength: 1000,
    iconMaxLength: 1000,
  },
  estimationModelEntity: {
    nameMaxLength: 100,
    descriptionMaxLength: 1000,
    aiRequestTemplateMaxLength: 3000,
  },
  estimationModelItemEntity: {
    nameMaxLength: 300,
    descriptionMaxLength: 1000,
    calculationRefMaxLength: 100,
    calculationFormulaMaxLength: 1000,
    format: /^[a-zA-Z0-9_-]+$/,
  },
  estimationModelItemGroupEntity: {
    nameMaxLength: 100,
    descriptionMaxLength: 1000,
  },
  estimationModelAdditionalFieldDefinitionEntity: {
    nameMaxLength: 100,
    descriptionMaxLength: 1000,
    guidedModeQuestionMaxLength: 1000,
  },
  estimationModelAssumptionCategoryEntity: {
    nameMaxLength: 100,
    descriptionMaxLength: 1000,
  },
  estimationModelItemParameterEntity: {
    labelMaxLength: 100,
    calculationRefMaxLength: 20,
    format: /^[a-zA-Z0-9_-]+$/,
  },
  methodologyEntity: {
    nameMaxLength: 100,
    descriptionMaxLength: 1000,
    calculationFormulaMaxLength: 1000,
  },
  methodologyParameterEntity: {
    labelMaxLength: 100,
    calculationRefMaxLength: 20,
    format: /^[a-zA-Z0-9_-]+$/,
  },
  estimationEntity: {
    versionMaxLength: 128,
  },
  estimationItemEntity: {
    nameMaxLength: 300,
    descriptionMaxLength: 1000,
    omitReasonStrippedHtmlMaxLength: 210,
    omitReasonMaxLength: 1000,
  },
  projectEntity: {
    nameMaxLength: 100,
  },
  estimationAssumptionEntity: {
    descriptionMaxLength: 1000,
  },
  estimationAdditionalFieldEntity: {
    valueMaxLength: 3000,
  },
  resourceTypeEntity: {
    nameMaxLength: 50,
    descriptionMaxLength: 1000,
  },
  costTypeEntity: {
    nameMaxLength: 50,
    descriptionMaxLength: 1000,
  },
  estimationItemAssumptionEntity: {
    descriptionMaxLength: 1000,
  },
};
